export class ApiError extends Error {
  constructor(
    message: string,
    public cause?: unknown,
    public code?: string | number
  ) {
    super(message);
    this.name = "ApiError";
  }
}
